import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-four',
  templateUrl: './theme-four.component.html',
  styleUrls: ['./theme-four.component.css']
})
export class ThemeFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
